import React from 'react';
import { Link } from 'react-router-dom';

export const EndOfTenancy = () => {
  return (
    <section className="end-of-tenancy-container" id="end-of-tenancy">
      <div
        className="end-of-tenancy-heading"
        data-aos="fade-up"
        data-aos-delay="50"
        data-aos-duration="1200"
        data-aos-easing="ease-out"
      >
        <h2>End of Tenancy Cleaning</h2>
       
      </div>

      <div
        className="tenancy-before-after"
        data-aos="zoom-in"
        data-aos-delay="120"
        data-aos-duration="1500"
        data-aos-easing="ease-out"
      >
        
        <article className="tenancy-card">
          <div className="tenancy-image" id="tenancy-after-image"></div>
        </article>
      </div>

      <div
        className="tenancy-points"
        data-aos="fade-left"
        data-aos-delay="180"
        data-aos-duration="1400"
        data-aos-easing="ease-out"
      >
         <p>
          Moving out? We deliver deep, detail-focused end of tenancy cleans designed to help
          you hand over the property in excellent condition.
        </p>
        <p>Kitchen degreasing, appliance wipe-downs, limescale removal, and bathroom sanitising.</p>
        <p>Dusting, skirting boards, doors, windows, and high-touch areas cleaned throughout.</p>
        <p>Flexible appointments for tenants, landlords, and letting agents across domestic properties.</p>
        <p>
          <Link className="tenancy-page-link" to="/end-of-tenancy-cleaning-tunbridge-wells">
            View our full end of tenancy cleaning guide
          </Link>
        </p>
      </div>
    </section>
  );
};

export default EndOfTenancy;